const a = {
  default: "var(--plac-icon-outline)",
  error: "var(--plac-status-error)",
  success: "var(--plac-status-success)",
  warning: "var(--plac-status-warning)"
}, r = {
  fill: "var(--plac-icon-outline)",
  light: "var(--plac-primary-white)",
  outline: "transparent",
  "fill-on-hover": "transparent"
};
export {
  r as UTILITY_ALERT_ICONS_FILL_BY_VARIANT_MAP,
  a as UTILITY_ALERT_ICONS_OUTLINE_COLORING_MAP
};
//# sourceMappingURL=index.es5659.js.map
